"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileEditIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ProfileEditIcon = function ProfileEditIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "16",
    fill: "#13131C",
    "fill-opacity": "0.45"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_1764_282684)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.7188 11.0312L23.8906 12.8594L20.1406 9.10938L21.9688 7.28125C22.1562 7.09375 22.3906 7 22.6719 7C22.9531 7 23.1875 7.09375 23.375 7.28125L25.7188 9.625C25.9062 9.8125 26 10.0469 26 10.3281C26 10.6094 25.9062 10.8438 25.7188 11.0312ZM8 21.25L19.0625 10.1875L22.8125 13.9375L11.75 25H8V21.25Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_1764_282684"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(5 4)"
  }))));
};
exports.ProfileEditIcon = ProfileEditIcon;